import { SquaredLogo } from "@/assets/logos";
import { Button } from "@/components/buttons";
import { useAuth0 } from "@auth0/auth0-react";
import "twin.macro";

export const SignIn = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <div tw="fixed inset-0 z-50 p-8 h-screen w-full bg-primary-800 flex flex-col gap-16 justify-center items-center select-none">
      <div tw="h-72 w-screen absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 rounded-bl-[70%] bg-primary-600/50" />

      <div tw="h-72 w-screen absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/3 rounded-tr-[70%] bg-primary-900/75" />

      <SquaredLogo onPrimary />

      <Button
        onprimary
        tw="rounded-md z-50"
        onClick={() => void loginWithRedirect()}
      >
        Se connecter
      </Button>
    </div>
  );
};
